import Icon from '../../components/Icon.vue'

Icon.register({"brands/adn":{"width":496,"height":512,"paths":[{"d":"M248 167.5L312.9 266.3H183.1L248 167.5zM496 256C496 392.9 384.9 504 248 504S0 392.9 0 256 111.1 8 248 8 496 119.1 496 256zM396.2 338.7L248 115.5 99.8 338.7H130.2L163.8 287H332.4L366 338.7H396.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/adn.js
// module id = null
// module chunks = 